<template>
    <div>
        <ion-item lines="none">
            <ion-input
                placeholder="Anzahl"
                type="number"
                v-model="number"
            ></ion-input>
            <ion-select
                placeholder="Bitte wählen"
                v-model="time"
                cancelText="Abbrechen"
                interface="popover"
            >
                <ion-select-option value="Jahre">Jahre</ion-select-option>
                <ion-select-option value="Monate">Monate</ion-select-option>
            </ion-select>
        </ion-item>
        <next-question-button
            @click="
                $emit('done', {
                    value: number + ' ' + time,
                    id: question.id,
                })
            "
            :disabled="number === '' || time === ''"
        />
    </div>
</template>

<script>
import NextQuestionButton from "./NextQuestionButton";
import { IonItem, IonInput, IonSelect, IonSelectOption } from "@ionic/vue";

export default {
    components: {
        NextQuestionButton,
        IonItem,
        IonInput,
        IonSelect,
        IonSelectOption,
    },
    props: {
        question: {
            required: true,
            type: Object,
        },
    },
    data() {
        return {
            number: "",
            time: "",
        };
    },
};
</script>

<style></style>
